<div class="chat-widget">
  <!-- Floating button -->
  <button class="chat-toggle" (click)="openChat()">
    Corporate Agent 💬
  </button>
  <!-- Chat window -->
  <div *ngIf="isOpen" class="chat-window">
    <div id="webchat" class="chat-box"></div>
  </div>
</div>
